import script from "./HistoriqueConversations.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoriqueConversations.vue?vue&type=script&setup=true&lang=js"

import "./HistoriqueConversations.vue?vue&type=style&index=0&id=7340692c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7340692c"]])

export default __exports__